import { defineComponent, onUnmounted, ref, computed } from '@vue/composition-api';
import { throttle } from 'lodash-es';
import { isLowPhone, lrpx2px } from '@/utils/device';
import PhotosItem from '../sub-components/photos-item.vue';
import { useToScrollHook } from '../hooks';
import useStore from '../store';
export default defineComponent({
  components: {
    PhotosItem: PhotosItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, ctx) {
    var _useToScrollHook = useToScrollHook(),
        handleTouchStart = _useToScrollHook.handleTouchStart,
        handleTouchEnd = _useToScrollHook.handleTouchEnd,
        handleTouchMove = _useToScrollHook.handleTouchMove;

    var photosItemRefs = ref([]);
    var photoTitleRef = ref(null);
    var photoTitleY = computed(function () {
      if (photoTitleRef.value) {
        return photoTitleRef.value.getBoundingClientRect().top || 0;
      }

      return 0;
    });
    var topList = computed(function () {
      return props.list.map(function (item, index) {
        return {
          top: photoTitleY.value + lrpx2px(319) * index,
          photoIdStr: item.photo_id_str
        };
      });
    });
    var store = useStore();

    var handleScroll = function handleScroll() {
      var scrollY = window.scrollY - lrpx2px(20);
      var item = topList.value.find(function (item) {
        return item.top > scrollY;
      });
      store.setCurrentPlayedPhotoIdStr(item === null || item === void 0 ? void 0 : item.photoIdStr);
    };

    var _handleScroll = isLowPhone ? throttle(handleScroll, 300) : handleScroll;

    window.addEventListener('scroll', _handleScroll);
    onUnmounted(function () {
      window.removeEventListener('scroll', _handleScroll);
    });
    return {
      handleTouchStart: handleTouchStart,
      handleTouchEnd: handleTouchEnd,
      handleTouchMove: handleTouchMove,
      photosItemRefs: photosItemRefs,
      store: store,
      photoTitleRef: photoTitleRef
    };
  }
});